export type EditionPeriodiqueType =
  | 'recapitulatif_periodique_mr'
  | 'recapitulatif_periodique_produit'
  | 'recapitulatif_periodique_produit_mr'
  | 'recapitulatif_periodique_journalier_produit_mr'
  | 'recapitulatif_periodique_budget_produit_imputation'
  | 'recapitulatif_periodique_journalier_recu'
  | 'bordereaux_remise_periodique';

export type EditionPeriodiqueOptionType = {
  key: EditionPeriodiqueType;
  label: string;
  detailParJournee?: boolean;
};

export const EDITIONS_PERIODIQUES_OPTIONS: readonly EditionPeriodiqueOptionType[] = [
  {
    key: 'recapitulatif_periodique_mr',
    label: 'Récapitulatif journalier des encaissements par mode de règlement',
  },
  {
    key: 'recapitulatif_periodique_produit',
    label: 'Récapitulatif journalier des encaissements par produit',
  },
  {
    key: 'recapitulatif_periodique_produit_mr',
    label: 'Récapitulatif des encaissements par produit et mode de règlement',
  },
  {
    key: 'recapitulatif_periodique_journalier_produit_mr',
    label: 'Récapitulatif journalier des encaissements par produit et mode de règlement',
  },
  {
    key: 'recapitulatif_periodique_budget_produit_imputation',
    label: 'Récapitulatif des encaissements par budget / produit / imputations',
  },
  {
    key: 'recapitulatif_periodique_journalier_recu',
    label: 'Récapitulatif journalier des encaissements par reçu',
  },
  {
    key: 'bordereaux_remise_periodique',
    label: 'Bordereaux de remise',
  },
];
